import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlError extends BaseControl {
    private _message: HTMLDivElement;

    constructor(pano: Pano) {
        super(pano, ControlPosition.CONTAINER);

        this.element.classList.add("error-container");
        this.element.innerHTML = `
            <div class="box">
                <div class="icon icon-857"></div>
                <div class="message"></div>
            </div>
        `;
        this._message = this.element.querySelector(".message");

        this.element.addEventListener("click", () => this.hide());
        this.pano.video.addEventListener("error", (e: ErrorEvent) => this.show(e.error));
        this.pano.onChangeVideo.add(() => this.hide());
        this.pano.onError.add((err) => {
            this.show(err);
        });
    }

    private show(err: Error = null): void {
        var message = err ? err.message : "Leider ist ein Fehler aufgetreten";
        this._message.textContent = message;
        this.pano.element.classList.add("error");
        this.element.classList.add("active");
    }

    private hide(): void {
        this.pano.element.classList.remove("error");
        this.element.classList.remove("active");
    }
}